module.exports = __webpack_public_path__ + "img/milho-selecionado.67269fe2.svg";